// @ts-nocheck
import { IconButton, Checkbox } from '@mui/material';
import { XGRadio } from 'xg-cl';
import { DotsSixVertical, PencilSimple } from '@phosphor-icons/react';
import DeleteButton from '../../../Layout/DeleteButton/DeleteButton';
import { useTranslation } from 'react-i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';
import {
  REQUIRED,
  OPTIONAL,
  HIDDEN,
  INTERNAL
} from '../../../../constants/passengerFieldStatuses';
import { preventBubbling } from '../../../../utils/eventHelper';
import '../PassengersFieldsTable/PassengersFieldsTable.css';
import * as PropTypes from 'prop-types';

/**
 * Render the passengers field table row
 *
 * @param {object} field - Field data object
 * @param {function} updatedFieldStatus - Callback function for update action
 * @param {function} handleDelete - Callback function for delete action
 * @param {function} handleEdit - Callback function for edit action
 * @param {function} onCheckBoxChange - Callback function for checkbox change
 * @return {JSX.Element} The passengers field table row component
 */
const PassengersFieldsRow = ({
  field,
  updatedFieldStatus,
  handleDelete,
  handleEdit,
  onCheckBoxChange,
  isSubmitting
}) => {
  const { isoptional, isrequired, ishidden, isinternal } = field;
  const { t } = useTranslation(['passengers', 'common']);
  const { enableInternalPassengerFields } = useFlags();

  const handleChangeSelect = (event) => {
    preventBubbling(event);
    updatedFieldStatus(field, event?.target?.value);
  };

  const handleRowClick = (event) => {
    const target = event?.target;
    const isChildrenOfStatus = target?.closest('.passengersfields_status');
    const isFromRadiosContainer =
      target?.classList?.contains('cell-content') ||
      target?.classList?.contains('passengersfields_status') ||
      isChildrenOfStatus;

    if (!enableInternalPassengerFields) return;

    // In here we check if the target is not input, label or button then we call handleEdit
    if (
      target.tagName !== 'INPUT' &&
      target.tagName !== 'LABEL' &&
      target.tagName !== 'BUTTON' &&
      !target.closest('button') &&
      !isFromRadiosContainer
    ) {
      if (!isSubmitting) handleEdit(field?.passengerfieldid);
    }
  };

  return (
    <table
      className={`passengersfields_table ${enableInternalPassengerFields ? 'passengersfields_table-row passengersfields_default-table' : ''}`}
      onClick={handleRowClick}
    >
      <tbody>
        <tr>
          {enableInternalPassengerFields ? (
            <>
              <td>
                <div className='cell-content'>
                  <DotsSixVertical
                    className='passengersfields_icon'
                    color='#344054'
                    size={22}
                    style={{ marginRight: '8px' }}
                  />

                  <Checkbox
                    id='amenity-default-checkbox'
                    name='debounce'
                    checked={!ishidden}
                    onChange={onCheckBoxChange}
                    color='primary'
                    sx={{ padding: '0px' }}
                  />
                </div>
              </td>
              <td> {field?.title || ''}</td>
            </>
          ) : (
            <td>
              <DotsSixVertical
                className='passengersfields_icon'
                color='#344054'
                size={22}
              />
              {field?.title || ''}
            </td>
          )}

          <td>
            <div className='passengersfields_status-container'>
              <div className='passengersfields_status'>
                <XGRadio
                  id={`passenger-field-option-required-${field?.passengerfieldid}`}
                  name={`field-status-${field?.passengerfieldid}`}
                  label={t('common:required')}
                  variant='pill'
                  size='small'
                  value={REQUIRED}
                  checked={isrequired}
                  onChange={handleChangeSelect}
                />
                <XGRadio
                  id={`passenger-field-option-optional-${field?.passengerfieldid}`}
                  name={`field-status-${field?.passengerfieldid}`}
                  label={t('common:optional')}
                  variant='pill'
                  size='small'
                  value={OPTIONAL}
                  checked={isoptional}
                  onChange={handleChangeSelect}
                />
                {!enableInternalPassengerFields && (
                  <XGRadio
                    id={`passenger-field-option-hidden-${field?.passengerfieldid}`}
                    name={`field-status-${field?.passengerfieldid}`}
                    label={t('common:hidden')}
                    variant='pill'
                    size='small'
                    value={HIDDEN}
                    checked={ishidden}
                    onChange={handleChangeSelect}
                  />
                )}
                {enableInternalPassengerFields && (
                  <XGRadio
                    id={`passenger-field-option-internal-${field?.passengerfieldid}`}
                    name={`field-status-${field?.passengerfieldid}`}
                    label={t('common:internal')}
                    variant='pill'
                    size='small'
                    value={INTERNAL}
                    checked={isinternal}
                    onChange={handleChangeSelect}
                  />
                )}
              </div>

              <div style={{ marginLeft: '24px', display: 'flex' }}>
                <DeleteButton
                  disabled={isSubmitting}
                  onClick={(event) => {
                    preventBubbling(event);
                    handleDelete(field?.passengerfieldid);
                  }}
                />

                {!enableInternalPassengerFields && (
                  <IconButton
                    aria-label={t('common:edit')}
                    onClick={(event) => {
                      preventBubbling(event);
                      handleEdit(field?.passengerfieldid);
                    }}
                  >
                    <PencilSimple size={24} color='#1361D8' />
                  </IconButton>
                )}
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

PassengersFieldsRow.propTypes = {
  field: PropTypes.object,
  updatedFieldStatus: PropTypes.func,
  handleDelete: PropTypes.func,
  handleEdit: PropTypes.func,
  onCheckBoxChange: PropTypes.func,
  isSubmitting: PropTypes.bool
};

export default PassengersFieldsRow;
